export const APP_VERSION = "0.0.0";

export const PROPAGANDA_LINES: readonly string[] = [
	// Baseline / sector reports
	"SECTOR 04 // CONTESTED // REINFORCEMENTS STANDING BY",
	"SECTOR 07 // CONTESTED // TERMINID ACTIVITY: HIGH",
	"SECTOR 12 // PACIFIED // CIVILIAN EVACUATION: 34% COMPLETE",
	"AUTOMATON PUSH REPELLED // GRID 88-R // CASUALTIES ACCEPTABLE",
	"SUPPLY CONVOY EN ROUTE // ETA: 14 HOURS // REMAIN AT POST",
	"WEATHER ADVISORY // ACID RAIN // DURATION INDEFINITE // CONTINUE OPERATIONS",
	"DESTROYER FLEET // 94.1% OPERATIONAL // ORBITAL WINDOW: OPEN",
	"BUG PURGE IN PROGRESS // AUTOMATON THREAT: ELEVATED",
	"MANAGED DEMOCRACY PROTOCOL ACTIVE // ALL SECTORS NOMINAL",

	// Policy reminders
	"REMINDER // UNAUTHORIZED SURRENDER IS A TREASONABLE OFFENSE",
	"FRIENDLY FIRE INCIDENTS MUST BE FILED WITHIN 48 HOURS OF RESPAWN",
	"STIMS ARE A SHARED RESOURCE // DO NOT HOARD",
	"IF YOU SEE SOMETHING, DEMOCRACY IT",
	'"I THOUGHT IT WAS A BUG" IS NOT A VALID AFTER-ACTION DEFENSE',
	'REPORT ANY DIVER EXPRESSING "DOUBT" TO THE NEAREST OFFICER',
	"FRIENDLY FIRE REMAINS UNFRIENDLY // CITIZENS, BE ADVISED",
	"TREASON WATCH: LEVEL 2 // REPORT DISSIDENTS",

	// Stats & indices
	"DEMOCRACY INDEX: 97.4% // REMAIN VIGILANT",
	"MANAGED DEMOCRACY INDEX: 98.2% // ALL CITIZENS EXCEEDING EXPECTATION",
	"LIBERTY QUOTA: 112% // EXCEEDING EXPECTATIONS",
	"TREASON QUOTA: 0.3% // MARGIN: COMFORTABLE",
	"AVERAGE HELLDIVER LIFESPAN: TRENDING POSITIVE",
	"BUG BIOMASS PROCESSED: 1.4M TONNES // AHEAD OF SCHEDULE",
	"HELLPODS DEPLOYED THIS CYCLE: 4,129,884 // REINFORCEMENTS: UNLIMITED",
	"HELLDIVE DIFFICULTY ENDORSED BY MINISTRY OF TRUTH",

	// Casualty & reinforcement bureaucracy
	"REINFORCEMENT CREDITS // UNLIMITED // PLEASE CONTINUE DYING AS NEEDED",
	"SQUAD WIPE REPORTED // GRID 44-K // REPLACEMENTS DISPATCHED",
	"HELLDIVER 778-C-91184 // KIA // COMMENDED FOR EFFICIENT SACRIFICE",

	// Redactions
	"[REDACTED] // CLEARANCE INSUFFICIENT // CEASE INQUIRY",
	"MEMO // [REDACTED] // FORWARD TO [REDACTED] // DO NOT DISCUSS",
	"DOSSIER ACCESS LOGGED // CITIZEN: YOU // REASON: PATRIOTISM",
	"SUPER EARTH ARCHIVE // DOSSIERS CLASSIFIED // CLEARANCE: HELLDIVER",

	// Tone-setters
	"MORALE: MANDATORY // ENFORCEMENT: ONGOING",
	"THE BUGS DID NOT FILL OUT THE PROPER FORMS // THEIR CLAIM IS INVALID",
	"THANK YOU FOR YOUR SERVICE // AGAIN",
	"CITIZENS, REMEMBER // DESPAIR IS A RESOURCE OF THE ENEMY",

	// Offense — Pyro
	"INCENDIARY AUDIT // DIVER'S OWN BOOTS CITED AS IGNITION SOURCE // AGAIN",
	"PSA // IF YOUR SQUADMATE SMELLS LIKE FUEL, DO NOT OFFER A LIGHT",
	"COMMENDATION // 47 TONNES OF BIO-MASS INCINERATED // MINISTRY OF COMBUSTION APPROVES",

	// Offense — Arc Trooper
	"ADVISORY // ARC WEAPON USE // MAINTAIN 10M FROM SQUADMATES // OR DON'T // WE LOG EITHER WAY",
	'INCIDENT // DIVER REPORTEDLY "FIXED" A FABRICATOR BY ELECTROCUTING IT // RESULTS PENDING',
	"CHAIN LIGHTNING IS NOT FRIENDLY FIRE // IT IS ENVIRONMENTAL",

	// Offense — Beamer
	"DIVER OBSERVED IGNORING RESUPPLY POD FOR SEVENTH CONSECUTIVE DROP // STATUS: SMUG",
	"REMINDER // HEAT SINKS ARE NOT MAGAZINES // STOP ASKING FOR AMMO",
	"CITIZEN RECOGNITION // ZERO ROUNDS EXPENDED // BATTERY AT 2% // DEMOCRACY SUSTAINED",

	// Offense — Bombardier
	"MORTAR IMPACT REPORTED IN GRID 12-B // ORIGIN: UNCONFIRMED // APOLOGIES: NONE",
	"ADVISORY // DO NOT STAND WHERE THE ARROW POINTS // DO NOT STAND WHERE IT DOESN'T",
	"COMMENDATION // DIVER ACHIEVED KILL WITHOUT EVER SEEING TARGET // EXEMPLARY",

	// Offense — Cadet
	"WELCOME ABOARD, CADET // YOUR PREDECESSOR'S DOG TAGS ARE IN THE DRAWER",
	"REMINDER // CADETS // THE BLUE ONES ARE GRENADES",
	"NEW ARRIVALS PROCESSED: 2,847 // EXPECTED RETENTION: STATISTICAL",

	// Offense — Demoman
	"STRUCTURAL ADVISORY // IF IT IS STANDING // IT IS TEMPORARY",
	"CRATER SURVEY // GRID 09-M // 14 NEW DEPRESSIONS // TWO UNCLAIMED BODIES",
	"DEMOLITIONS REFRESHER // YELLING \"FIRE IN THE HOLE\" IS COURTESY // AFTER THAT IT'S SOMEONE ELSE'S PROBLEM",

	// Offense — Eagle Master
	"EAGLE-1 REQUESTS YOU STOP WAVING // SHE CAN SEE YOU // SHE IS CHOOSING NOT TO",
	'SORTIE LOG // 47 STRIKES // 46 ON TARGET // ONE "PRACTICE"',
	'EAGLE PILOT CALLSIGN "MURDER AUNT" // USE RANK IN OFFICIAL REPORTS',

	// Offense — Fumigator
	"ATMOSPHERIC ADVISORY // TASTE IN MOUTH // METALLIC // IS NORMAL // DO NOT REPORT",
	"STATE V MURPHY // HAVING SMELT IT IS INSUFFICIENT EVIDENCE ON ITS OWN FOR CONVICTION OF HAVING DEALT IT // KNOW YOUR RIGHTS",
	"THE GREEN CLOUD IS YOURS // THE YELLOW CLOUD IS ALSO YOURS // DO NOT RUN",

	// Offense — Heavy Gunner
	"AMMUNITION ADVISORY // GUNNER-CLASS DIVERS // PLEASE LEAVE SOME FOR THE REST OF US",
	'NOISE COMPLAINT LODGED // GRID 22-V // RESPONSE: "WHAT?"',
	"COMMENDATION // SUSTAINED FIRE FOR 84 SECONDS // HEARING TEST SCHEDULED POSTHUMOUSLY",

	// Offense — Orbital Master
	"DESTROYER GUNNERY UPDATE // YES THAT WAS ON PURPOSE // YES IT COUNTS",
	"FINAL CALL FOR 380MM BARRAGE // THIS IS NOT A DRILL // IT IS A THURSDAY",

	// Offense — Rocketeer
	"REPORTED RELOAD TIME: 2.1S // UNVERIFIED // TEAMMATES IMMOLATED BEFORE CONFIRMING",
	"BACKBLAST ZONE ADVISORY // STAND BEHIND // OR DON'T // IT'S LOUD EITHER WAY",
	"COMMENDATION // ONE ROCKET // ONE CHARGER // ONE VERY CLOSE ESCAPE",

	// Scout — Assassin
	"TARGETED ELIMINATION CONFIRMED // HIGH-VALUE TERMINID // NO WITNESSES REMAINING ANYWAY",
	"PSA // THAT SQUADMATE WHO NEVER ANSWERS COMMS // PROBABLY BEHIND ENEMY LINES // DO NOT WAIT UP",
	"INCIDENT // DIVER LANDED ON COMMANDER'S SHOULDERS // COMMANDER NO LONGER REQUIRES SHOULDERS",

	// Scout — Berserker
	"INCIDENT // DIVER ATTEMPTED TO MELEE A BILE TITAN // OUTCOME: PREDICTABLE // MORALE: UNCHANGED",
	"AMMO EXPENDITURE: ZERO // CAUSE OF DEATH: CONTACT // CLASSIFICATION: INSPIRING",
	"REMINDER // THE ENTRENCHMENT TOOL IS A SHOVEL // WHAT YOU DIG WITH IT IS UP TO YOU",

	// Scout — Sniper
	"DIVER OBSERVED PRONE IN SAME DITCH FOR 41 MINUTES // CONFIRMED ALIVE // CONFIRMED UNWELCOME",
	"ADVISORY // IF THE SNIPER IS AIMING // YOU ARE ALREADY LATE",
	"COMMENDATION // ONE ROUND // ONE BILE TITAN // THREE SQUADMATES DOWN BEFORE IMPACT // STILL COUNTS",

	// Support — Lazy Boy
	"COMMENDATION // DIVER COMPLETED FULL OPERATION WITHOUT STANDING // EFFICIENCY: COMMENDABLE",
	"PSA // THE MECH IS A WEAPON // NOT A SOFA // THOUGH IT DOES RECLINE",
	"VEHICLE USAGE REPORT // 94% SEATED // 6% ADJUSTING LUMBAR",

	// Support — Medic
	"ADVISORY // STIM PISTOL IS NOT A WEAPON // CEASE FILING IT AS A KILL",
	"REMINDER // THE MEDIC IS NOT AN AMMO BOX // DO NOT SHAKE THEM",
	'INCIDENT // DIVER STIMMED ENEMY COMBATANT // REASON: "SHE LOOKED TIRED" // UNDER REVIEW',

	// Support — Oursman
	"MINEFIELD NOTICE // GRID 17-D // WATCH YOUR STEP // AND YOUR LEGS // AND YOUR FRIENDS",
	'INCIDENT // DIVER YELLED "OURS" // OPERATION WAS ALREADY LOST BY THAT POINT',
	"CLAIM FILED // ONE LEFT BOOT // CLAIMANT: OURSMAN // FORMER OWNER: UNAVAILABLE FOR COMMENT",

	// Support — Quartermaster
	"RESUPPLY CALLED BY DIVER WHO HAS NEVER MISSED ONE // STILL // JUST IN CASE",
	"COMMENDATION // 14 SUPPLY PACKS DISTRIBUTED // ZERO REQUESTED // SERVICE UNPROMPTED",
	"REMINDER // THE QUARTERMASTER KEEPS RECORDS // OF EVERY STIM YOU DIDN'T THANK THEM FOR",

	// Support — Sentry
	'TURRET KILL LOG // 312 CONFIRMED // DIVER\'S CONTRIBUTION: "SUPERVISION"',
	"INCIDENT // DIVER CLOCKED OUT MID-ENGAGEMENT // UNION REPRESENTATION FORTHCOMING",
	"SENTRY MAINTENANCE MEMO // THEY ARE DOING THEIR BEST // THEY ARE ALSO UNIONIZED",

	// Support — Wheelman
	'VEHICLE INCIDENT // DRIVER DESCRIBED GROUND AS "A SUGGESTION" // TWO PASSENGERS UNACCOUNTED FOR',
	"FRV MILEAGE REPORT // 0 KM ON TERRAIN // 4.8 KM AIRBORNE",
	"PSA // IF YOU HEAR THE ENGINE // YOU ARE IN THE KILL ZONE // ALSO IN THE VEHICLE",

	// Wildcard
	"WILDCARD DESIGNATION LOGGED // NO TACTICAL SYNERGY // NO REFUNDS",
	"RANDOMIZATION COMPLETE // LOADOUT: INADVISABLE // DEPLOYMENT: ANYWAY",
	"INCIDENT // DIVER CHARGED WHILE SHOUTING INDECIPHERABLE SYLLABLES // KILLS: 14 // DEATH: ALMOST IMMEDIATE",
];
